import ImageZoom from "components/imageZoom/ImageZoom";
import "./vengeance.scss";
import vengeanceCover from "assets/img/home/vengeance/vengeanceCover.webp";
import vengeanceCoverMob from "assets/img/home/vengeance/vengeanceCoverMob.webp";
import vengeance1 from "assets/img/home/vengeance/vengeance1.webp";
import vengeance2 from "assets/img/home/vengeance/vengeance2.webp";
import vengeance3 from "assets/img/home/vengeance/vengeance3.webp";
import { VENGEANCE_ID } from "constant";
import { Link, useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import productStore from "store/productStore";
import cartStore from "store/cartStore";
import { useEffect, useState } from "react";
import ReactPixel from "react-facebook-pixel";
import { ENV } from "constant";
import authStore from "store/authStore";
import ImageSlider from "../imageSlider/ImageSlider";
import imageLoadStore from "store/imageLoadStore";

const Vengeance = () => {
  const ImageLoadStore = imageLoadStore();
  const navigate = useNavigate();

  const ProductStore = productStore();
  const AuthStore = authStore();
  const CartStore = cartStore();
  const [product, setProduct] = useState(null);
  const [isAddToCartLoading, setIsAddToCartLoading] = useState(false);
  const [isAddToCart, setIsAddToCart] = useState(false);

  useEffect(() => {
    fetchSpecificProductRating();
  }, []);

  const fetchSpecificProductRating = async () => {
    const product = await ProductStore.fetchOneProduct({
      _id: VENGEANCE_ID,
    });
    setProduct(product);
  };

  useEffect(() => {
    if (CartStore.cartProduct && product) {
      setIsAddToCart(false);
      const isCart = CartStore.cartProduct.find(
        (item) => item.productID === product._id,
      );
      if (isCart) {
        setIsAddToCart(true);
      }
    }
  }, [CartStore.cartProduct && CartStore.cartProduct.length, product]);

  const AddToCart = async () => {
    if (AuthStore.isLogged) {
      setIsAddToCartLoading(true);
      await CartStore.signInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
      setIsAddToCartLoading(false);
    } else {
      await CartStore.noSignInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
    }

    if (ENV === "production") {
      ReactPixel.track("AddToCart", {
        content_ids: [product._id],
        content_name: product.productName,
        value: product.salePrice ? product.salePrice : product.regularPrice,
        currency: "INR",
      });
    }
    navigate("/checkout");
  };

  return (
    <div className="vengeance-home">
      <div className="first-container">
        <div className="image-container">
          <img src={vengeanceCoverMob} alt="vengeance-perfume-background" />
        </div>

        <div className="text-container">
          <div className="text-wrapper">
            <h2>Vengeance</h2>
            <div className="quote-container">
              <q>Bold. Powerful. Unforgettable.</q>
              <p>
                Vengeance is a fragrance for those who lead with heart and build
                lasting legacies. It is a commanding scent that blends strength
                with sophistication, designed for the modern individual who
                makes their own rules.
              </p>
            </div>
            <div className="button-container">
              <Link
                to={`/perfume/vengeance/${VENGEANCE_ID}/details`}
                className="link learn-more-link"
                onClick={() => {
                  ImageLoadStore.setImageLoading(true);
                }}
              >
                Learn More
              </Link>
              <LoadingButton
                loading={isAddToCartLoading}
                onClick={
                  isAddToCart
                    ? () => {
                        navigate("/checkout");
                      }
                    : AddToCart
                }
                className="btn btn-buy-now"
              >
                Buy Now
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
      <div className="second-container">
        <div className="left-container">
          <div className="image-container">
            <div className="left-image img-content">
              <ImageZoom src={vengeance3} alt="vengeance-left" />
            </div>
          </div>
          <div className="quote-content">
            <q>
              Bold spicy perfume, signature evening scent, luxury intense
              fragrance.
            </q>
          </div>
        </div>
        <div className="right-container">
          <div className="image-container">
            <div className="right-move-container">
              <div className="right-first-image img-content">
                <ImageZoom src={vengeance1} alt="vengeance-first-right" />
              </div>
            </div>
            <div className="right-second-image img-content">
              <ImageZoom src={vengeance2} alt="vengeance-second-right" />
            </div>
          </div>
        </div>
      </div>
      <ImageSlider
        alt="vengeance"
        images={[vengeance1, vengeance2, vengeance3]}
        quoteText={
          "SwBold spicy perfume, signature evening scent, luxury intense fragrance."
        }
      />
    </div>
  );
};

export default Vengeance;
